import { useContext } from 'react'
import { AppContext } from '../../providers'
import arcadeApiClient from '../../apiClients/arcadeApiClient'
import { RewardCard } from 'ui/types/RewardCard'
import useSWR from 'swr'

const rewardFetcher = async (url: string): Promise<RewardCard[]> =>
  await arcadeApiClient.get(url).then(res => res.data.rewards)

export const useFavoriteRewards = () => {
  const { setToast } = useContext(AppContext)

  const {
    data: favoritedData,
    mutate: mutateFavorites,
    isLoading,
  } = useSWR('multi_platform/rewards/favourites', rewardFetcher)

  const addFavorite = (reward: RewardCard) =>
    arcadeApiClient({
      method: 'POST',
      url: `/multi_platform/rewards/${reward.id}/reward_favourites`,
      data: {
        reward_type: 'arcade_reward',
      },
    }).then(response => {
      reward.rewardFavouriteId = response.data.id
      setToast({
        status: 'success',
        description: `You added ${reward.name} to your favorites!`,
      })
    })

  const removeFavorite = (reward: RewardCard) =>
    arcadeApiClient({
      method: 'DELETE',
      url: `/multi_platform/rewards/${reward.id}/reward_favourites/${reward.rewardFavouriteId}`,
    }).then(() => {
      reward.rewardFavouriteId = null
      setToast({
        status: 'success',
        description: `You removed ${reward.name} from your favorites!`,
      })
    })

  const favoritedItems = favoritedData || ([] as RewardCard[])

  return {
    favoritedItems,
    addFavorite,
    removeFavorite,
    mutateFavorites,
    isLoading,
  }
}
